import { render, staticRenderFns } from "./BankingPage.vue?vue&type=template&id=71151226&scoped=true"
import script from "./BankingPage.vue?vue&type=script&lang=js"
export * from "./BankingPage.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "71151226",
  null
  
)

export default component.exports